import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ContratoSelecionarFormaPagamentoModule, FooterModule, HeaderModule } from '@usucampeao/ui-mobile';
import { PipesModule } from '@usucampeao/utils-frontend';
import { DetalhesSuperSocialModule } from 'libs/ui-mobile/src/lib/pages/cadastros-novo/detalhes-super-social/detalhes-super-social.module';
import { NgxMaskModule } from 'ngx-mask';
import { ListagemMoradoresComRendaPageRoutingModule } from './listagem-moradores-com-renda-routing.module';
import { ListagemMoradoresComRendaPage } from './listagem-moradores-com-renda.page';
import { MoradorComRendaCardComponent } from './morador-com-renda-card/morador-com-renda-card.component';

@NgModule({
  declarations: [
    ListagemMoradoresComRendaPage,
    MoradorComRendaCardComponent,
  ],
  imports: [
    // root
    CommonModule,
    IonicModule,
    FormsModule,
    // route
    ListagemMoradoresComRendaPageRoutingModule,
    // components
    ContratoSelecionarFormaPagamentoModule,
    DetalhesSuperSocialModule,
    HeaderModule,
    FooterModule,
    // Pipes
    PipesModule,
    // external
    NgxMaskModule,
  ]
})
export class ListagemMoradoresComRendaPageModule { }
